export default __webpack_public_path__ + "static/media/icon-xbox.9e14ee9d.svg";